import { MapTo } from '@adobe/aem-react-editable-components';
import spreadModelProps from 'helpers/spreadModelProps';
import ErrorBanner from './ErrorBanner';

export default MapTo('aweb/components/content/error-banner')(spreadModelProps(ErrorBanner));
